import request from '@/request'
import { LOCATION } from '@/data/api'
import { bindVar, objQueryString } from '@/util'

export default {
  namespaced: true,
  state: {
    locationList: [],
    streetList: [],
    fuseboxList: [],
    networkList: [],
    energyList: [],
    limit: 3,
    pagination: {
      page: 1,
      lastPage: 0,
      total: 0
    },
    paginationCity: {
      page: 1,
      lastPage: 0,
      total: 0
    },
    paginationAddr: {
      page: 1,
      lastPage: 0,
      total: 0
    },
    searchCity: '',
    searchAddr: '',
    search: ''
  },
  getters: {
    fuseboxList: state => state.fuseboxList,
    locationList: state => state.locationList,
    streetList: state => state.streetList,
    networkList: state => state.networkList,
    energyList: state => state.energyList,
    lastPage: state => state.pagination.lastPage,
    currentPage: state => state.pagination.page,
    total: state => state.pagination.total,
    search: state => state.search,
    lastPageCity: state => state.paginationCity.lastPage,
    currentPageCity: state => state.paginationCity.page,
    totalCity: state => state.paginationCity.total,
    searchCity: state => state.searchCity,
    lastPageAddr: state => state.paginationAddr.lastPage,
    currentPageAddr: state => state.paginationAddr.page,
    totalAddr: state => state.paginationAddr.total,
    searchAddr: state => state.searchAddr,
    isFilterApplied: (state) => {
      return !!state.search
    },
    isFilterAppliedCity: (state) => {
      return !!state.searchCity
    },
    isFilterAppliedAddr: (state) => {
      return !!state.searchAddr
    }
  },
  mutations: {
    setNetworkList (state, items) {
      state.networkList = items
    },
    setEnergyList (state, items) {
      state.energyList = items
    },
    setLocationList (state, items) {
      state.locationList = items
    },
    setFuseboxList (state, items) {
      state.fuseboxList = items
    },
    setStreetList (state, items) {
      state.streetList = items
    },
    setPage (state, page) {
      state.pagination.page = page
    },
    setLastPage (state, page) {
      state.pagination.lastPage = page
    },
    setTotal (state, count) {
      state.pagination.total = count
    },
    setSearch (state, search) {
      state.search = search
    },
    setPageAddr (state, page) {
      state.paginationAddr.page = page
    },
    setLastPageAddr (state, page) {
      state.paginationAddr.lastPage = page
    },
    setTotalAddr (state, count) {
      state.paginationAddr.total = count
    },
    setSearchAddr (state, search) {
      state.searchAddr = search
    },
    setPageCity (state, page) {
      state.paginationCity.page = page
    },
    setLastPageCity (state, page) {
      state.paginationCity.lastPage = page
    },
    setTotalCity (state, count) {
      state.paginationCity.total = count
    },
    setSearchCity (state, search) {
      state.searchCity = search
    },
    clearItems (state) {
      state.locationList = []
      state.streetList = []
      state.fuseboxList = []
    }
  },
  actions: {
    async get ({ commit, getters }) {
      try {
        const queryParams = {
          page: getters.currentPageCity,
          keyword: getters.searchCity
        }
        const { data } = await request.get(`${LOCATION.RESOURCE}?${objQueryString(queryParams)}`)
        commit('setLocationList', data.data)
        commit('setLastPageCity', data.meta.last_page)
        commit('setTotalCity', data.meta.total)
      } catch (e) {
        commit('setLocationList', [])
        commit('setLastPageCity', 0)
        commit('setTotalCity', 0)
      }
    },
    async getStreets ({ commit, getters }, city) {
      try {
        const queryParams = {
          page: getters.currentPageAddr,
          keyword: getters.searchAddr
        }
        const { data } = await request.get(`${bindVar(LOCATION.STREET, { city })}?${objQueryString(queryParams)}`)
        commit('setStreetList', data.data)
        commit('setLastPageAddr', data.meta.last_page)
        commit('setTotalAddr', data.meta.total)
      } catch (e) {
        commit('setStreetList', [])
        commit('setLastPageAddr', 0)
        commit('setTotalAddr', 0)
      }
    },
    async getFusebox ({ commit, getters }, loc) {
      try {
        const queryParams = {
          page: getters.currentPage,
          keyword: getters.search
        }
        const { data } = await request.get(`${bindVar(LOCATION.FUSEBOX, loc)}?${objQueryString(queryParams)}`)
        commit('setFuseboxList', data.data)
        commit('setLastPage', data.meta.last_page)
        commit('setTotal', data.meta.total)
      } catch (e) {
        commit('setFuseboxList', [])
        commit('setLastPage', 0)
      }
    },
    resetPage ({ commit }, payload) {
      if (payload.resetPage) {
        commit('setPage', 1)
      }
    },
    resetFilters ({ commit }) {
      commit('setSearch', '')
    },
    resetPageAddr ({ commit }, payload) {
      if (payload.resetPage) {
        commit('setPageAddr', 1)
      }
    },
    resetFiltersAddr ({ commit }) {
      commit('setSearchAddr', '')
    },
    resetPageCity ({ commit }, payload) {
      if (payload.resetPage) {
        commit('setPageCity', 1)
      }
    },
    resetFiltersCity ({ commit }) {
      commit('setSearchCity', '')
    },
    async add ({ commit }, params) {
      try {
        await request.post(LOCATION.RESOURCE, params)
      } catch (e) {
        throw e
      }
    },
    async update (context, params) {
      try {
        await request.post(`${LOCATION.RESOURCE}/${params.uuid}`, params.form)
      } catch (e) {
        throw e
      }
    },
    async delete (context, id) {
      try {
        await request.delete(`${LOCATION.RESOURCE}/${id}`)
        return
      } catch (e) {
        throw e
      }
    },
    async init ({ commit, getters }) {
      try {
        const { data } = await request.get(`${LOCATION.INIT}`)
        commit('setNetworkList', data.networks)
        commit('setEnergyList', data.energies)
        return data
      } catch (e) {
        throw e
      }
    }
  }
}
